'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for(o = 0; o < a.length; o++)t = a[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, a = Object.keys(e);
    for(o = 0; o < a.length; o++)t = a[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const BannerSecondaryImage = renderWithRef('BannerSecondaryImage', null, (t, o)=>{
    var { imageFocalPoint: n, children: a } = t, i = _object_without_properties(t, [
        "imageFocalPoint",
        "children"
    ]);
    let c = new Set([
        'swan-banner-image',
        'swan-banner-secondary-image'
    ]);
    return n && c.add(`swan-banner-image-focal-point-${n.replace(/ +/g, '-')}`), jsx(RenderComp, {
        root: "div",
        forwardedRef: o,
        classNames: c,
        props: i,
        children: a
    });
});

export { BannerSecondaryImage };
